import { createAction, handleActions, combineActions } from 'redux-actions';
import { fromJS, Map, List } from 'immutable';
import { createSelector } from 'reselect';
import { normalize, schema } from 'normalizr';

// Schemas
const deviceEntity = new schema.Entity('devices');

// Actions
export const fetchDevices = createAction('DEVICES_FETCH');
export const fetchDevicesSuccess = createAction('DEVICES_FETCH_SUCCESS');
export const fetchDevicesFail = createAction('DEVICES_FETCH_FAIL');

export const fetchDevice = createAction('DEVICE_FETCH');
export const fetchDeviceSuccess = createAction('DEVICE_FETCH_SUCCESS');
export const fetchDeviceFail = createAction('DEVICE_FETCH_FAIL');

export const createDevice = createAction('DEVICE_CREATE');
export const createDeviceFail = createAction('DEVICE_CREATE_FAIL');

export const updateDevice = createAction('DEVICE_UPDATE');
export const updateDeviceFail = createAction('DEVICE_UPDATE_FAIL');

export const deleteDevice = createAction('DEVICE_DELETE');
export const deleteDeviceSuccess = createAction('DEVICE_DELETE_SUCCESS');
export const deleteDeviceFail = createAction('DEVICE_DELETE_FAIL');

export const actions = {
  fetchDevices,
  fetchDevicesSuccess,
  fetchDevicesFail,
  fetchDevice,
  fetchDeviceSuccess,
  fetchDeviceFail,
  createDevice,
  createDeviceFail,
  updateDevice,
  updateDeviceFail,
  deleteDevice,
  deleteDeviceSuccess,
  deleteDeviceFail,
}

const defaultState = fromJS({
  result: List([]),
  data: {},
  isFetching: false,
  error: {}
})

export default handleActions({
  [combineActions(
    fetchDevices,
    fetchDevice,
  )]: (state) => {
    return state.merge({
      isFetching: true,
    });
  },

  [fetchDevicesSuccess]: (state, action) => {
    const normalizedData = normalize(action.payload, [deviceEntity]);
    return state.merge({
      result: normalizedData.result,
      data: normalizedData.entities.devices || {},
      isFetching: false
    })
  },

  [fetchDeviceSuccess]: (state, action) => {
    const normalizedData = normalize(action.payload, deviceEntity)
    return state.merge({
      result: [],
      data: normalizedData.entities.devices,
      isFetching: false,
    });
  },

  [deleteDeviceSuccess]: (state, action) => {
    const { id } = action.payload;
    const result = state.get('result');
    const data = state.get('data');

    return state.merge({
      result: result.delete(result.indexOf(id)),
      data: data.delete(id),
    });
  },

  [combineActions(
    fetchDevicesFail,
    fetchDeviceFail,
    createDeviceFail,
    updateDeviceFail,
  )]: (state, action) => {
    return state.merge({
      error: action.payload,
      isFetching: false
    })
  }
}, defaultState)

// selectors
const resultSelector = state => state.device.data.get('result');
const devicesSelector = state => state.device.data.get('data')
const isFetchingSelector = state => state.device.data.get('isFetching')
const paginationSelector = state => state.device.pagination

export const getDevices = createSelector(
  resultSelector,
  devicesSelector,
  (result, devices) => result.map(id => devices.get(String(id))).toJS(),
)

export const getDevice = (state, id) =>
  (devicesSelector(state).get(String(id)) || new Map()).toJS()

export const isFetching = createSelector(
  isFetchingSelector,
  isFetching => isFetching
)

export const getDevicesPagination = createSelector(
  paginationSelector,
  paginationData => paginationData.toJS(),
);



// WEBPACK FOOTER //
// ./src/store/deviceReducer.js